export default __webpack_public_path__ + "static/media/new_dashboard_careplan_icon.53068f6e.svg";